import React from 'react'
import { browserHistory } from 'react-router'

import LoginImageSlider from './LoginImageSlider'

export default class LoginLeftPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    signup(e) {
        e.preventDefault();
        browserHistory.replace('/signup');
    }

    render(){
        return (
            <div class="col-md-12 col-sm-12 login-left-panel-background">
                <div class="row">
                    <div class="col-md-2 login-panel-item login-left-panel-text">
                        <h3 class="login-left-panel-text">Ready to get started?</h3>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-md-2 login-panel-item center" >
                        <button type="submit" onClick={this.signup} name="submit"  class="btn btn-info btn-fill">Create an Account</button>
                    </div>
                </div>
                <br />
                <br />
                <div class="row">
                    <LoginImageSlider />
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Login/LoginLeftPanel.jsx